import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=a947a0ce&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=a947a0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a947a0ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a947a0ce')) {
      api.createRecord('a947a0ce', component.options)
    } else {
      api.reload('a947a0ce', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=a947a0ce&scoped=true&", function () {
      api.rerender('a947a0ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4B60lnwoq7AQO/JS/teamMember.vue"
export default component.exports